import React from 'react';
import { AutoComplete, Select, Button, Space, Divider, Input } from 'antd';
import { SearchOutlined, UserAddOutlined } from '@ant-design/icons';
import { ArrowDownTrayIcon } from '@heroicons/react/20/solid';
import { DateFilters } from '../../common';
import { exportUsersToCSV } from '../../../utils/exportUtils';
import styles from './styles/table-actions.module.scss';

const { Option } = Select;

function ReportsUsersTableActions({
    setRows,
    users,
    handleFilterChange,
    resetFilters,
    applyFilters,
    handleTimeFrameChange,
    handleDateRangeChange,
    filters,
    rows
}) {
    const [suggestions, setSuggestions] = React.useState([]);
    const [showFilters, setShowFilters] = React.useState(false);
    const [ddSwitchDisabled, setDDSwitchDisabled] = React.useState(false);

    React.useEffect(() => {
        setSuggestions(users);
    }, [users]);

    const onSearch = (search) => {
        const filteredData = users.filter((c) => c.name.toLowerCase().includes(search.toLowerCase()));
        setSuggestions(filteredData);
        setRows(filteredData, 'users');
    };

    const handleDownloadExcel = () => {
        exportUsersToCSV(rows || users);
    };

    const handleEnrollmentChange = (value) => {
        handleFilterChange('enrollment', value);
        // Disable DD incomplete filter when selecting 'with_activity'
        setDDSwitchDisabled(value === 'with_activity');
        if (value === 'with_activity' && filters.hasCompleteDDSwitch === 'incomplete') {
            handleFilterChange('hasCompleteDDSwitch', null); // Clear invalid selection
        }
    };

    return (
        <div className={styles.container}>
            {/* Search and Action Bar */}
            <div className={styles.searchAndActionsBar}>
                <div className={styles.searchContainer}>
                    <Input placeholder="Search" onChange={(e) => onSearch(e.target.value)} className={styles.searchInput} />
                    <Button type="primary" icon={<SearchOutlined />} className={styles.searchButton} />
                </div>
                <div className={styles.actionButtons}>
                    <Button type="default" icon={<UserAddOutlined />} onClick={handleDownloadExcel} className={styles.actionButton}>
                        Export as XLSX
                    </Button>
                    <Button type={showFilters ? 'primary' : 'default'} onClick={() => setShowFilters(!showFilters)} className={styles.actionButton}>
                        Add Filters
                    </Button>
                </div>
            </div>

            {/* Advanced Filters Section */}
            {showFilters && (
                <div className={styles.filtersSection}>
                    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                        {/* Enrollment and Usage Filters */}
                        <Space wrap size="large" style={{ width: '100%' }}>
                            <div style={{ width: '100%', maxWidth: '250px' }}>
                                <p className={styles.filtersTitle}>Enrollment Status</p>
                                <Select
                                    placeholder="Enrollment Status"
                                    style={{ width: '100%' }}
                                    onChange={handleEnrollmentChange}
                                    value={filters.enrollment}
                                    allowClear>
                                    <Option value="enrolled">Enrolled (Timeframe)</Option>
                                    <Option value="with_activity">With Advances</Option>
                                    <Option value="without_activity">Without Advances</Option>
                                </Select>
                            </div>

                            <div style={{ width: '100%', maxWidth: '250px' }}>
                                <p className={styles.filtersTitle}>DD Switch Status</p>
                                <Select
                                    placeholder="DD Switch Status"
                                    style={{ width: '100%' }}
                                    onChange={(value) => handleFilterChange('hasCompleteDDSwitch', value)}
                                    value={filters.hasCompleteDDSwitch}
                                    disabled={ddSwitchDisabled}
                                    allowClear>
                                    <Option value="complete">Complete</Option>
                                    <Option value="incomplete">Incomplete</Option>
                                </Select>
                            </div>
                        </Space>

                        <Divider style={{ margin: '12px 0' }} />
                        <div>
                            <p className={styles.filtersTitle}>Timeframe</p>
                            <div className={styles.timeframeSection}>
                                <DateFilters
                                    activeTimeFrame={filters.timeFrame}
                                    onTimeFrameChange={handleTimeFrameChange}
                                    onDateRangeChange={handleDateRangeChange}
                                />
                                <div className={styles.filtersButtons}>
                                    <Button type="primary" onClick={applyFilters}>
                                        Apply Filters
                                    </Button>
                                    <Button onClick={resetFilters}>Reset All</Button>
                                </div>
                            </div>
                        </div>
                    </Space>
                </div>
            )}
        </div>
    );
}

export default ReportsUsersTableActions;
